const templateUrl = require('./unsent-shipment-list.html');

const app = angular.module('msi.shipments.unsentShipmentList', []);

app.component('ogUnsentShipmentList', {
  bindings: {
    shipments: '=ogFor'
  },
  templateUrl: templateUrl
});

module.exports = app.name;
